import { useState } from 'react';
import { callAPI, Method } from '../commonFunctions/CommonFunctions';
import axios from 'axios';
import http from '../commonFunctions/httpClient';

export const useProduct = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const createProduct = async (productData: any) => {
        try {
            setLoading(true);
            setError(null);
            const response = await http.postFormData(`Vyapar/Product`, productData);
            // const response = axios.post(`http://192.168.1.167:5001/Vyapar/Product`, productData, {
            //     headers: {
            //         'Content-Type': 'multipart/form-data',
            //         'Authorization': `Bearer ${localStorage.getItem('accessToken')}`, // Include token if needed
            //     },
            // });
            console.log('Created product:', response);
            
            return response
        } catch (err: any) {
            setError(err.response?.data?.message || 'Failed to create product');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const updateProduct = async (id: string, productData: any) => {
        try {
            setLoading(true);
            setError(null);
            const response = await callAPI(`Vyapar/Product/${id}`, Method.PUTFORMDATA, productData);
            return response;
        } catch (err: any) {
            setError(err.response?.data?.message || 'Failed to update product');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const getProduct = async (id: string) => {
        try {
            setLoading(true);
            setError(null);
            const response = await callAPI(`Vyapar/Product/${id}`, Method.GET);
            return response;
        } catch (err: any) {
            setError(err.response?.data?.message || 'Failed to fetch product');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const getProducts = async (params?: any) => {
        try {
            setLoading(true);
            setError(null);
            const results = await callAPI('Vyapar/Product', Method.GET, params);
            return results;
        } catch (err: any) {
            setError(err.response?.data?.message || 'Failed to fetch products');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const deleteProduct = async (id: string) => {
        try {
            setLoading(true);
            setError(null);
            const response = await callAPI(`Vyabar/products/${id}`, Method.DELETE);
            return response.data;
        } catch (err: any) {
            setError(err.response?.data?.message || 'Failed to delete product');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        createProduct,
        updateProduct,
        getProduct,
        getProducts,
        deleteProduct,
    };
};